import { cryptoUtil } from "./CryptoUtil";

export const STORAGE = {
    SDK: "sd",
    SESSION: "s",
    USER: "u",
    SESSION_CRYPTOFACIL: "scf",
    USER_CRYPTOFACIL: "ucf",
};

export const clearStorage = (name) => {
    window.sessionStorage.removeItem(name);
}

export const clearAllStorage = () => {
    Object.entries(STORAGE).forEach(([_, value]) => {
        clearStorage(value);
    });
}

const setStorage = (name, value) => {
    return window.sessionStorage.setItem(name, cryptoUtil.encode(value));
}

const getStorage = (name) => {
    let item = window.sessionStorage.getItem(name);
    if (item) {
        return cryptoUtil.decode(item).replace(/^"|"$/g, '');
    }
    return item;
}

export const getSession = () => {
    return getStorage(STORAGE.SESSION);
}

export const setSession = (value) => {
    return setStorage(STORAGE.SESSION, value);
}

export const getUser = () => {
    let storage = getStorage(STORAGE.USER);
    if (storage) {
        return JSON.parse(storage);
    }
    return storage;
}

export const setUser = (value) => {
    return setStorage(STORAGE.USER, value);
}

export const getSdk = () => {
    return getStorage(STORAGE.SDK);
}

export const setSdk = (value) => {
    return setStorage(STORAGE.SDK, value);
}

// nuevo cryptofacil
export const getSessionCryptofacil = () => {
    return getStorage(STORAGE.SESSION_CRYPTOFACIL);
}

export const getUserCryptofacil = () => {
    return getStorage(STORAGE.USER_CRYPTOFACIL);
}

export const setSessionCryptofacil = (value) => {
    return setStorage(STORAGE.SESSION_CRYPTOFACIL, value);
}

export const setUserCryptofacil = (value) => {
    return setStorage(STORAGE.USER_CRYPTOFACIL, value);
}